import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, MessageCircle, ArrowRight } from 'lucide-react';
import confetti from 'canvas-confetti';

const CheckoutSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
    
    // 🎉 Animação de confetes
    const duration = 3000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    const interval = setInterval(function() {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);
      
      // Confetes da esquerda
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
      });
      
      // Confetes da direita
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
      });
    }, 250);

    // Limpeza ao desmontar
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        {/* Success Card */}
        <div className="bg-gradient-to-br from-slate-900 to-slate-800 border border-slate-700 rounded-3xl p-8 md:p-12 text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-500" />
          </div>

          <h1 className="text-3xl md:text-4xl font-black text-white mb-4">
            Pagamento Aprovado! 🎉
          </h1>

          <p className="text-xl text-gray-300 mb-8">
            Sua assinatura foi confirmada com sucesso!
          </p>

          {/* Info Box */}
          <div className="bg-cyan-500/10 border border-cyan-500/30 rounded-2xl p-6 mb-8 text-left">
            <div className="flex items-start gap-3 mb-4">
              <MessageCircle className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-white font-bold mb-2">Credenciais Enviadas</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Suas credenciais de acesso foram enviadas para o WhatsApp cadastrado. 
                  Você receberá em instantes:
                </p>
              </div>
            </div>

            <ul className="space-y-2 ml-9">
              <li className="text-gray-300 text-sm">✅ Email de login</li>
              <li className="text-gray-300 text-sm">✅ Chave de acesso única</li>
              <li className="text-gray-300 text-sm">✅ Link direto para a plataforma</li>
              <li className="text-gray-300 text-sm">✅ Data de validade</li>
            </ul>
          </div>

          {/* Next Steps */}
          <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 mb-8 text-left">
            <h3 className="text-white font-bold mb-4">Próximos Passos:</h3>
            <ol className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
                  1
                </span>
                <span className="text-gray-300 text-sm">
                  Verifique seu WhatsApp e salve suas credenciais
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
                  2
                </span>
                <span className="text-gray-300 text-sm">
                  Acesse a plataforma com o link recebido
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
                  3
                </span>
                <span className="text-gray-300 text-sm">
                  Comece a gerenciar suas apostas profissionalmente
                </span>
              </li>
            </ol>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => navigate('/login')}
              className="flex-1 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white font-bold rounded-xl hover:from-green-600 hover:to-green-700 transition-all transform hover:scale-105 flex items-center justify-center gap-2"
            >
              <span>Acessar Plataforma</span>
              <ArrowRight className="w-5 h-5" />
            </button>

            <button
              onClick={() => navigate('/')}
              className="flex-1 py-4 bg-slate-800 border border-slate-700 text-white font-bold rounded-xl hover:bg-slate-700 transition-all"
            >
              Voltar ao Início
            </button>
          </div>

          {/* Support */}
          <div className="mt-8 pt-6 border-t border-slate-700">
            <p className="text-gray-400 text-sm">
              Não recebeu as credenciais?{' '}
              <a
                href="https://wa.me/5511916560595"
                target="_blank"
                rel="noopener noreferrer"
                className="text-cyan-400 hover:text-cyan-300 font-medium"
              >
                Entre em contato pelo WhatsApp
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
